import { render, staticRenderFns } from "./auditoriums.vue?vue&type=template&id=d967004e&scoped=true"
import script from "./auditoriums.vue?vue&type=script&lang=js"
export * from "./auditoriums.vue?vue&type=script&lang=js"
import style0 from "./auditoriums.vue?vue&type=style&index=0&id=d967004e&prod&lang=css"
import style1 from "./auditoriums.vue?vue&type=style&index=1&id=d967004e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d967004e",
  null
  
)

export default component.exports